import { Injectable } from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';

@Injectable({ providedIn: 'root' })
export class DirectoryFilterStateService {
    constructor(private readonly session: SessionStorageService) { }

    load(directory: 'shipments' | 'deliveries'): unknown {
        const key = this.key(directory);
        if (!key) return null;
        try {
            return JSON.parse(window.localStorage.getItem(key) || 'null');
        } catch {
            try { window.localStorage.removeItem(key); } catch { /* storage may be unavailable */ }
            return null;
        }
    }

    save(directory: 'shipments' | 'deliveries', state: unknown): void {
        const key = this.key(directory);
        if (!key) return;
        try { window.localStorage.setItem(key, JSON.stringify(state)); } catch { /* private browsing can disable storage */ }
    }

    clear(directory: 'shipments' | 'deliveries'): void {
        const key = this.key(directory);
        if (key) try { window.localStorage.removeItem(key); } catch { /* storage may be unavailable */ }
    }

    private key(directory: string): string | null {
        const companyId = this.session.getCompany()?.id;
        const customerId = this.session.getCustomer()?.id;
        return companyId && customerId ? `directory-filters:v1:${directory}:${companyId}:${customerId}` : null;
    }
}
